/** Settings panels added by workflows phase 3: custom attributes and SLA policies. Merged into `settings`. */
export const settingsP3 = {
  attributes: {
    title: "Attributes",
    subtitle: "Custom fields that workflows can set and branch on. Your site fills them with Sagot('identify'); steps and staff set the rest.",
    add: "Add attribute",
    addTitle: "Add an attribute",
    editTitle: "Edit attribute",
    dialogHint: "The object, key and type are fixed once the attribute exists, because stored values depend on them.",
    saved: "Attribute saved",
    deleted: "Attribute deleted",
    deleteTitle: "Delete {{name}}?",
    deleteBody: "Values already stored on visitors, conversations or leads are kept, but workflows can no longer use them.",
    delete: "Delete",
    inUse: "Workflows still use this attribute. Remove it from their steps and conditions first, then delete it.",
    object: "Belongs to",
    objects: { visitor: "Visitor", conversation: "Conversation", lead: "Lead" },
    type: "Type",
    types: { text: "Text", number: "Number", bool: "Yes / no", date: "Date", list: "List of choices" },
    label: "Name",
    labelPlaceholder: "e.g. Grade level",
    labelRequired: "Enter a name.",
    key: "Key",
    keyHint: "Lower-case letters, numbers and _, starting with a letter. Used in workflows and by identify.",
    keyInvalid: "Use lower-case letters, numbers and _, starting with a letter (up to 40).",
    keyTaken: "This object already has an attribute with that key.",
    options: "Choices",
    optionsHint: "One per line, up to {{max}}.",
    optionsRequired: "Add at least one choice, up to {{max}}.",
    optionTooLong: "Each choice can have up to {{max}} characters.",
    optionCount_one: "{{count}} choice",
    optionCount_other: "{{count}} choices",
    edit: "Edit",
    editOne: "Edit {{name}}",
    deleteOne: "Delete {{name}}",
    actions: "Actions",
    save: "Save attribute",
    emptyTitle: "No attributes yet",
    emptyBody: "Define attributes such as grade level or budget, then set them from workflows or from your site, and branch on them.",
    limit: "You have reached the limit of {{max}} attributes. Delete one to add another.",
  },
  sla: {
    title: "SLA policies",
    subtitle: "Response and resolution targets that the Apply SLA policy step starts on a conversation.",
    add: "Add policy",
    addTitle: "Add an SLA policy",
    editTitle: "Edit SLA policy",
    dialogHint: "Targets are in minutes. The clock starts when a workflow applies the policy.",
    saved: "SLA policy saved",
    deleted: "SLA policy deleted",
    deleteTitle: "Delete {{name}}?",
    deleteBody: "Conversations already running on it keep their targets.",
    delete: "Delete",
    inUse: "Workflows still apply this policy. Change those steps first, then delete it.",
    gateTitle: "SLA policies are on the Institution plan",
    gateBody: "Set first-response and resolution targets, see a Due in / Breached chip in the Inbox, and alert your team before a target is missed.",
    name: "Name",
    namePlaceholder: "e.g. Admissions priority",
    nameRequired: "Enter a name.",
    nameTaken: "An SLA policy with that name already exists.",
    firstResponse: "First response",
    nextResponse: "Next response",
    resolution: "Resolution",
    minutesHint: "In minutes, up to 365 days.",
    minutesOf: "{{target}} in minutes",
    officeHoursOnly: "Count office hours only",
    warnBefore: "Warn before",
    warnHint: "Minutes before a target when “Before an SLA is breached” workflows run. Use 0 for no warning.",
    warnTooLong: "The warning must come earlier than your shortest target.",
    save: "Save policy",
    edit: "Edit",
    editOne: "Edit {{name}}",
    deleteOne: "Delete {{name}}",
    actions: "Actions",
    clock: "Clock",
    officeOnly: "Office hours",
    always: "Around the clock",
    emptyTitle: "No SLA policies yet",
    emptyBody: "Create a policy, then add an “Apply SLA policy” step to a workflow.",
    limit: "You have reached the limit of {{max}} policies. Delete one to add another.",
  },
} as const;
